import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { DocumentPreviewStore } from '../../stores';
import { IAppStoreBase, ISessionStoreBase } from '../../types';
import TextSearch from './TextSearch';
import FullScreenButton from './FullScreenButton';
import MinimapToggleButton from './MinimapToggleButton';
import './SideDocumentPreviewHeader.less';

interface Props {
    appStore: IAppStoreBase;
    sessionStore: ISessionStoreBase;
    documentPreviewStore: DocumentPreviewStore;
    lightMode?: boolean;
}

const SideDocumentPreviewHeader: React.FC<Props> = ({ documentPreviewStore, lightMode }) => {
    return (
        <div className="side-document-preview-header">
            {!documentPreviewStore.searchInputVisible && (
                <div className="left-container">
                    <span className="preview-label">Preview</span>
                </div>
            )}

            <div className="right-container">
                <TextSearch variant="outlined" documentPreviewStore={documentPreviewStore} lightMode={lightMode} />
                <FullScreenButton documentPreviewStore={documentPreviewStore} lightMode={lightMode} />
                {documentPreviewStore.showMinimapToggleButton && (
                    <MinimapToggleButton documentPreviewStore={documentPreviewStore} lightMode={lightMode} />
                )}
            </div>
        </div>
    );
};

export default observer(SideDocumentPreviewHeader);
